import { render, staticRenderFns } from "./CampaignsData.vue?vue&type=template&id=093b1b8a&scoped=true&"
import script from "./CampaignsData.vue?vue&type=script&lang=ts&"
export * from "./CampaignsData.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignsData.vue?vue&type=style&index=0&id=093b1b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b1b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('093b1b8a')) {
      api.createRecord('093b1b8a', component.options)
    } else {
      api.reload('093b1b8a', component.options)
    }
    module.hot.accept("./CampaignsData.vue?vue&type=template&id=093b1b8a&scoped=true&", function () {
      api.rerender('093b1b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/CampaignsData.vue"
export default component.exports